export default __webpack_public_path__ + "static/extended-data-frontend-view-7aa2ed03ca2adfb0cfa102567feeba60.png";